import PropTypes from "prop-types";
import React from "react";
import { Form } from "react-bootstrap";

export const CheckBoxApp = (props) => {
    const {
        name = "",
        label,
        infoText = "",
        errorText = "",
        style = {},
        onChange = () => {},
        checked = false,
        required = false,
        labelClassName = "",
        disabled = false,
     } = props;

    let inputProps = { ...props };

    delete inputProps.checked;
    delete inputProps.onChange;
    delete inputProps.infoText;
    delete inputProps.errorText;
    delete inputProps.labelClassName;
    delete inputProps.checkboxSize;

    const onCheckChange = (e) => {
        onChange({
            target: {
                name: e.target.name,
                value: e.target.checked,
            },
        });
    };

    return (
        <Form.Group controlId={name}>
            <Form.Check
                {...inputProps}
                style={style}
                id={`id-input-${name}`}
                checked={Boolean(checked)}
                onChange={onCheckChange}
                required={required}
                disabled={disabled}

                label={
                    <span className={labelClassName}>
                        {label}
                        {required ? " (*)" : ""}
                    </span>
                }
                custom="true"
            />

            <Form.Text className={`text-error`}>{errorText}</Form.Text>
            <Form.Text className={`text-muted`}>{infoText}</Form.Text>
        </Form.Group>
    );
};

CheckBoxApp.propTypes = {
    infoText: PropTypes.any,
    errorText: PropTypes.string,
    label: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    checkboxSize: PropTypes.number, // 👈 nuevo tipo
};
